import { render } from "./milestonesmodal.vue?vue&type=template&id=44db5a7f"
import script from "./milestonesmodal.vue?vue&type=script&lang=js"
export * from "./milestonesmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__